// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import GoogleMapReact from 'google-map-react';
import Geocode from 'react-geocode';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { ControlLabel } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityFormFieldWrapper from '../../ActivityForm/ActivityFormFieldWrapper';
import ActivityLocationFieldMarker from './ActivityLocationFieldMarker';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityLocationSearchBox from './ActivityLocationSearchBox';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { getConfig } from '../../../../config';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order

const StyledMapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  padding: 0 5px;
`;

const config = getConfig();
const { googleMapApiKey } = config;

Geocode.setApiKey(googleMapApiKey);
Geocode.setLocationType('ROOFTOP');

const DefaultCoordinates = {
  lat: 34.15974570762779,
  lng: -40.59635910156249,
};

export type LocationFileds = {
  name: string;
  value: LocationValue | string;
};

type LocationValue = {
  address: string;
  city: string | undefined;
  country: string | undefined;
  latitude: number;
  line1: string | undefined;
  line2: string | undefined;
  locationNotes: string | undefined;
  longitude: number;
  name?: string;
  postalCode: string | undefined;
  state: string | undefined;
  url: string | undefined;
};

const ActivityLocationField = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  location,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onMetaFieldsChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isMobileView,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isMobileEditMode,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  display,
}) => {
  const [position, setPosition] = useState({
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    lat: location?.latitude || DefaultCoordinates.lat,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    lng: location?.longitude || DefaultCoordinates.lng,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    address: location?.address || '',
  });

  const [addressChanged, setAddressChanged] = useState(false);

  const onClick = newPosition => {
    const { lat, lng } = newPosition;
    setPosition({ lat, lng, address: '' });
    setAddressChanged(true);
  };

  const onAutoCompleteChange = useCallback(
    async address => {
      const name = address.value.types.includes('point_of_interest')
        ? address.value.terms[0].value
        : undefined;

      const result = await geocodeByAddress(address.label);
      if (!result) return;

      const {
        geometry,
        formatted_address,
        address_components = [],
      } = result[0];
      const position = {
        lat: geometry.location.lat(),
        lng: geometry.location.lng(),
        address: formatted_address,
        name,
      };
      const { lat, lng } = await getLatLng(result[0]);
      if (lat && lng) {
        position.lat = lat;
        position.lng = lng;
      }
      const stateNameObj = address_components.find(
        component => component.types[0] === 'administrative_area_level_1'
      );
      const cityNameObj = address_components.find(
        component =>
          component.types[0] === 'locality' ||
          component.types[0] === 'administrative_area_level_2' ||
          component.types[0] === 'administrative_area_level_3'
      );
      const cityName = cityNameObj?.long_name;
      const stateName = stateNameObj?.short_name;
      const city = cityName && stateName ? `${cityName}, ${stateName}` : '';

      const streetNumberAddressComponent = address_components.find(
        component => component.types[0] === 'street_number'
      );

      const routeAddressComponent = address_components.find(
        component => component.types[0] === 'route'
      );

      const line1Components = [
        streetNumberAddressComponent,
        routeAddressComponent,
      ].reduce(
        (
          accumulatedStreetAddressComponents: string[],
          currentAddressComponent
        ) => {
          if (currentAddressComponent) {
            accumulatedStreetAddressComponents.push(
              currentAddressComponent.long_name
            );
          }

          return accumulatedStreetAddressComponents;
        },
        []
      );

      const line1 = line1Components.join(' ');

      const line2Component = address_components.find(
        component => component.types[0] === 'subpremise'
      );

      const line2 = line2Component ? line2Component.long_name : '';

      const country = address_components.find(
        component => component.types[0] === 'country'
      );

      const postalCodeAddressComponent = address_components.find(
        component => component.types[0] === 'postal_code'
      );

      const postalCodeSuffixAddressComponent = address_components.find(
        component => component.types[0] === 'postal_code_suffix'
      );

      const zipCodeComponents = [
        postalCodeAddressComponent,
        postalCodeSuffixAddressComponent,
      ].reduce(
        (accumulatedZipCodeComponents: string[], currentZipCodeComponent) => {
          if (currentZipCodeComponent) {
            accumulatedZipCodeComponents.push(
              currentZipCodeComponent.long_name
            );
          }

          return accumulatedZipCodeComponents;
        },
        []
      );

      const postalCode = zipCodeComponents.join('-');

      const newFields = [
        {
          name: 'location',
          value: {
            address: formatted_address,
            city: cityName,
            country: country?.short_name,
            latitude: position.lat,
            line1,
            line2,
            longitude: position.lng,
            name,
            postalCode,
            state: stateName,
          },
        },
      ];

      if (addressChanged) {
        newFields.push({
          name: 'city',
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          value: city,
        });
      }

      onMetaFieldsChange(newFields);
      setPosition(position);
    },
    [addressChanged, onMetaFieldsChange]
  );

  useEffect(() => {
    if (position.address && !position.lat && !position.lng) {
      onAutoCompleteChange(position.address);
    }
  }, [onAutoCompleteChange, position.address, position.lat, position.lng]);

  useEffect(() => {
    if (!location) {
      setPosition({
        lat: DefaultCoordinates.lat,
        lng: DefaultCoordinates.lng,
        address: '',
      });
    }
  }, [location]);

  return (
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    <ActivityFormFieldWrapper
      label='location'
      isMobileView={isMobileView}
      display={display}
    >
      <ControlLabel>Location:*</ControlLabel>
      <StyledMapWrapper isMobileView={isMobileView}>
        <ActivityLocationSearchBox
          apiKey={googleMapApiKey}
          value={position.address}
          onChange={onAutoCompleteChange}
          isMobileView={isMobileView}
          isMobileEditMode={isMobileEditMode}
        />
        <GoogleMapReact
          bootstrapURLKeys={{
            key: googleMapApiKey,
          }}
          center={position}
          defaultZoom={16}
          yesIWantToUseGoogleMapApiInternals
          onClick={onClick}
        >
          <ActivityLocationFieldMarker
            address={position.address}
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            lat={position.lat}
            lng={position.lng}
          />
        </GoogleMapReact>
      </StyledMapWrapper>
    </ActivityFormFieldWrapper>
  );
};

export default ActivityLocationField;
